import { AnyAction } from "redux";
import { LOAD_ALL_COUPON_TEMPLATES, LOAD_COUPON_TEMPLATE_BY_NUMBER } from "../actions/CouponActions";
import { CouponTemplateApiResponse, PaginatedCouponTemplateResponse } from "../models/coupon/CouponManagementDto";

export interface ICouponReducerState {
  allCouponTemplates?: PaginatedCouponTemplateResponse;
  selectedCouponTemplate?: CouponTemplateApiResponse;
}

export const coupons = (state: ICouponReducerState, action: AnyAction): ICouponReducerState => {
  switch (action.type) {
    case LOAD_ALL_COUPON_TEMPLATES:
      return {
        ...state,
        allCouponTemplates: action.payload,
      };

    case LOAD_COUPON_TEMPLATE_BY_NUMBER:
      return {
        ...state,
        selectedCouponTemplate: action.payload,
      };

    default:
      return state || {};
  }
};
